import React from 'react';
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { selectNav } from '../languages/languagesSlice'

const root = process.env.PUBLIC_URL

const Home = () => {
  const nav = useSelector(selectNav)
  return (
    <section className="home container">
      <img src={`${root}/assets/home-thumbnail.svg`} className="home-logo" alt="logo" />
      <Link to={`${root}/level`} className="btn btn-lg">{nav.play}</Link>
      <Link to={`${root}/about`} className="btn btn-lg">{nav.about}</Link>
    </section>
  )
}

export default Home